<router-outlet />

@defer {
    <stby-modal-for-root />
}

@defer (when showUserModal; prefetch on idle) {
    @if (showUserModal) {
        <stby-campaign-user [imageUrl]="campaign.imageUrl" (closeModal)="closeUserModal()" />
    }
}

@defer (when notice; prefetch on idle) {
    <stby-notice-modal [notice]="notice" />
}

@defer (when appModalVisible; prefetch on idle) {
    @if (appModalVisible) {
        <stby-app-notice (closeModal)="closeAppModal()" />
    }
}

@defer (when isMaintenanceMode(); prefetch on idle) {
    <stby-maintenance-modal />
}

@defer {
    <stby-feedback-form />
}

@if (testEnvironmentName) {
    <div class="test-env__background">
        <div class="test-env__text" [class]="[testEnvironmentName]"></div>
    </div>
}
